
import React from 'react';
import { Anchor, Box } from 'grommet';

import SectionTitle from './common/SectionTitle';
import ImagesPreviewPanel from './common/ImagesPreviewPanel';
import PropertyRows from './PropertyRows';

function getImages(odrudaDetail) {
    return odrudaDetail.data.fotky.map(item => {
        return {
            id: item.id,
            type: 'preview',
            fileName: item.file_name,
            title: item.title
        }
    });
}

const SectionImages = ({odrudaDetail}) => {
    return (
        <Box>
            <SectionTitle title="Fotodokumentace" />
            <ImagesPreviewPanel images={getImages(odrudaDetail)} />
        </Box>
    );
}

const SectionSsr = ({odrudaDetail}) => {
    return (odrudaDetail.data.attributes.dendrogram || odrudaDetail.data.attributes.ssr_tabulka)
        ? (
            <Box>
                <SectionTitle title="Genetická analýza" />
                <Box pad={{top: '18px'}} direction="row">
                    <Anchor href={`#/odrudassr/${odrudaDetail.id}`} label="Zobrazit stránku genetické analýzy" />
                </Box>
            </Box>
        )
        : null;
}
const SectionOverview = ({odrudaDetail}) => {

    const ATTRS = [
        ['Název odrůdy', 'nazev'],
        ['Synonyma', 'synonyma'],
        ['Lidový název', 'nazev_lidovy'],
        ['Původ názvu', 'nazev_popis'],
        ['Původní odrůdy', 'puvodni_odrudy'],
        ['Status odrůdy', 'status_odrudy'],
        ['Registrace v ČR', 'reg_cr'],
        ['Růst', 'rust'],
        ['Zrání', 'zrani'],
        ['Choroby a škůdci', 'choroby_skudci'],
        ['Výhony', 'vyhony'],
        ['Pupeny', 'pupeny'],
        ['Listy', 'list'],
        ['Květy', 'kvety'],
        ['Hrozen', 'hrozen'],
        ['Bobule', 'bobule'],
        ['Semeno', 'semeno'],
        ['Plodnost (výnos)', 'plodnost'],
        ['Analytické parametry', 'analytic_param'],
        ['Náročnost na stanoviště', 'narocnost_stanoviste'],
        ['Víno', 'vino']
    ];
    return (
        <PropertyRows attrDefs={ATTRS} attrValues={odrudaDetail.data.attributes} />
    );
}

const OdrudaDetail = ({odrudaDetail}) => {
    return (
        <Box gap="medium">
            <SectionOverview odrudaDetail={odrudaDetail} />
            <SectionSsr odrudaDetail={odrudaDetail} />
            <SectionImages odrudaDetail={odrudaDetail} />
        </Box>
    );
}

export default OdrudaDetail;
